/**
 * Тег кешу визначення модуля в просторі (ADR-023: визначення залежить від простору): `простір:модуль`; без простору — опубліковане
 * визначення (`:модуль`). Збереження налаштувань типу запису інвалідовує тег свого простору й модуля.
 */
export const moduleTag = (workspaceId: string | undefined, moduleKey: string) => ({ type: 'Module' as const, id: `${workspaceId ?? ''}:${moduleKey}` });
